import store, { persistor } from '../store';
import axios from 'axios';
import Utility from './Utility'
// import { createHashHistory } from 'history';
import { setLoginData, logout } from '../slices/userSlice';
import Config from './Config'

// get api api configure fn
export const get = (url, data, header = "global", external_url = false, secrect_key = "") => {
	return new Promise((resolve, reject) => {
		console.log("BASE_URL", Config.BASE_URL);
		let apiBaseUrl = `${Config.BASE_URL}${url}`;
		var params = data ? data.filters : {};
		let invokeError = true;
		// if (typeof params==="string") {
		// 	params = JSON.parse(params)
		// 	if (params.size_width && params.size_height) invokeError = false;
		// }
		axios.get(apiBaseUrl, {
			params: data,
			headers: getHeaders(header, url, external_url, secrect_key)
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			if (invokeError) {
				errorHandlingBlock(error)
			}
		})
	});
}

// post api api configure fn
export const post = (url, data, header = "global", external_url = false) => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = external_url ? url : `${Config.BASE_URL}${url}`;
		axios.post(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			let showErrorMessage = true;
			const errorMessage = error?.response?.data?.message ?? "";
			const normalizedMessage = errorMessage.toLowerCase();
			if (normalizedMessage === "user is not confirmed.") {
				showErrorMessage = false;
			}
			if (showErrorMessage) {
				errorHandlingBlock(error)
			}
		})
	});
}

export const postMultipart = (url, file, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${Config.BASE_URL}${url}`;

		const formData = new FormData();
		formData.append("image", file);

		axios
			.post(apiBaseUrl, formData, {
				headers: {
					...getHeaders(header, url),
					"Content-Type": "multipart/form-data",
					accept: "application/json",
				},
			})
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				reject(error);
				errorHandlingBlock(error);
			});
	});
};


// patch api api configure fn
export const patch = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${Config.BASE_URL}${url}`;
		axios.patch(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}

// put api api configure fn
export const put = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${Config.BASE_URL}${url}`;
		axios.put(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}

// delete api api configure fn
export const del = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${Config.BASE_URL}${url}`;
		axios.delete(apiBaseUrl, {
			data: data,
			headers: getHeaders(header, url)
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}

// download api configure fn
export const download = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${Config.BASE_URL}${url}`;
		axios.get(apiBaseUrl, {
			params: data,
			headers: getHeaders(header, url),
			responseType: 'arraybuffer'
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}

//Api header configure fn
export const getHeaders = (header, path = "", external_url = false, data = "") => {
	checkExpiryOfToken();

	const state = store.getState();
	const accessToken = state.user?.accessToken || "";
	const token = state.user?.token || "";
	const userType = state.user?.userType || "";  // <-- You wanted this added

	let headers = {
		language: localStorage.getItem("i18nextLng") || "en",
		accept: "*/*",             // required by your curl example
		authorization: token,      // raw token (no "Bearer")
		usertype: userType === "admin" ? "admin" : "user"         // same as curl (“admin”)
	};

	// When GET is from external URL
	if (external_url) {
		headers["secret_key"] = data;
	}

	// No header Object
	if (header === null) {
		return headers;
	}

	// GLOBAL HEADER HANDLING
	if (header === "global") {
		if (path === `${process.env.EXTENDED_URL}users/mfa/verify`) {
			headers["Session"] = state.user.session;

		} else if (
			path === `${Config.EXTENDED_URL}users/associate_software_token` ||
			path === `${Config.EXTENDED_URL}users/verify_software_token`
		) {
			headers["AccessToken"] = accessToken;

		} else if (
			path === `${Config.EXTENDED_URL}signout` ||
			path === `${Config.EXTENDED_URL}changepassword`
		) {
			headers["accesstoken"] = accessToken;
		}

		return headers;
	}

	// CUSTOM HEADER OBJECT
	if (typeof header === "object" && Object.keys(header).length > 0) {
		if (path === `${process.env.EXTENDED_URL}userforcepasswordchange`) {
			Object.assign(headers, header);

		} else if (
			path === `${process.env.EXTENDED_URL}signout` ||
			path === `${process.env.EXTENDED_URL}users/changepassword`
		) {
			localStorage.setItem("i18nextLng", "en");
			headers["Authorization"] = token;
			headers["Accesstoken"] = accessToken;
		}
	}

	return headers;
};

//id token expiration time check fn before every api call hits
export const checkExpiryOfToken = () => {
	const state = store.getState();
	const expiresIn = state?.user?.expiresIn || {};
	const expiryTimeMs = typeof expiresIn.expiryTime === 'number' ? expiresIn.expiryTime : 0;
	const loggedInTimeMs = typeof expiresIn.loggedInTime === 'number' ? expiresIn.loggedInTime : 0;
	const expiryIntervalSec = Number(expiresIn.expiryInterval) || 0;

	if (!expiryTimeMs) return;

	const nowMs = Date.now();
	const elapsedSec = (nowMs - loggedInTimeMs) / 1000;
	if (nowMs >= expiryTimeMs && elapsedSec <= expiryIntervalSec) {
		refershToken();
	}
};

//refershToken create api method
export const refershToken = () => {
	// const history = createHashHistory();
	const state = store.getState();
	let res = new Promise((resolve, reject) => {
		let header = {};
		header["Authorization"] = state.user.token;
		header["refreshToken"] = state.user.refreshToken;
		let apiBaseUrl = `${Config.BASE_URL}${Config.EXTENDED_URL}refreshtoken`;
		let data = {}
		// data["refreshToken"] = Store.default.getState().LoginReducer.refreshToken;
		axios.patch(apiBaseUrl, data, { headers: header }).then((response) => {
			resolve(response);
		}).catch((error) => {
			logoutApp()
		})
	});
	res.then((result) => {
		let finalResponse = result.data
		if (finalResponse.success) {
			const finalIdToken = finalResponse.data.tokenType + ' ' + finalResponse.data.idToken;
			const accessToken = finalResponse.data.accessToken
			const expiresIn = Utility.getExpiryDetails(finalResponse.data.expiresIn)

			store.dispatch(setLoginData({
				token: finalIdToken,
				accessToken: accessToken,
				expiresIn: expiresIn,
				// Maintain other existing state values
				name: store.getState().user.name,
				userCredentials: store.getState().user.userCredentials,
				version: store.getState().user.version,
				roleWisePermission: store.getState().user.roleWisePermission,
				userType: store.getState().user.userType,
				session: store.getState().user.session
			}));
		} else {
			Utility.toastNotifications("Oops session has been expired!!!", "Error", "error")
			logoutApp()
		}
	})

};

//logoutApp fn
export const logoutApp = async () => {
	// localStorage.setItem('i18nextLng', 'en');
	// // const history = createHashHistory();
	// const state = store.getState();
	// try {
	// 	const header = {
	// 		"Authorization": state.user.token,
	// 		"Accesstoken": state.user.accessToken
	// 	};
	// 	const apiBaseUrl = `${Config.BASE_URL}${Config.EXTENDED_URL}signout`;
	// 	await axios.delete(apiBaseUrl, {
	// 		data: {},
	// 		headers: header
	// 	});
	// 	store.dispatch(login({
	// 		token: "",
	// 		accessToken: "",
	// 		expiresIn: { loggedInTime: '', expiryTime: '', expiryInterval: '' },
	// 		name: "",
	// 		userCredentials: {},
	// 		version: "",
	// 		roleWisePermission: {},
	// 		userType: "patient",
	// 		session: ""
	// 	}));

	// 	// history.push(`/`);
	// 	localStorage.clear();
	// 	window.location.reload();
	// } catch (error) {
	// }
};

//error handler fn for api errors
export const errorHandlingBlock = (error) => {
	if (error.response) {

		if (error.response.status === 413) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				Utility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}

		if (error.response.status === 409) {
			if (Array.isArray(error.response.data)) {
				if (error.response.data.length > 0) {
					error.response.data.map((item) => {
						Utility.toastNotifications(item.message, "Error", "error");
					});
				}
			} else {
				Utility.toastNotifications(error.response.data.message, "Error", "error");
			}
		}

		if (error.response.status === 406) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				if (error.response.data.error === "Please make sure you have done full payments before checkout") {
					Utility.toastNotifications(error.response.data.message, "Warning", "warning");
				} else if (error.response.data.error.indexOf('Check-Out is not possible as payment of amount') !== -1) {
					Utility.toastNotifications(error.response.data.message, "Warning", "warning");
				} else {
					Utility.toastNotifications(error.response.data.message, "Error", "error");
				}
			}
		}
		if (error.response.status === 400) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				// if (error.response.data.message.toLowerCase() !== "you don't have any active organisation") {
				// 	Utility.toastNotifications(error.response.data.message, "Error", "error")
				// }
			}
		}

		if (error.response.status === 404) {
			if (Array.isArray(error.response.data)) {
				if (error.response.data[0].error)
					if (error.response.data[0].error.indexOf('Please settle them individually first') === -1) {
						Utility.toastNotifications(error.response.data[0].message, "Error", "error");
					}
			} else {
				Utility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}
		if (error.response.status === 422) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Warning", "warning");
			} else {
				Utility.toastNotifications(error.response.data.message, "Warning", "warning")
			}
		}

		if (error.response.status === 401) {
			if (error.response.data.message === "The incoming token has expired") {
				Utility.toastNotifications("Oops session has been expired!!!", "Error", "error")
				logoutApp()
			}
			logoutApp()
		} else if (error.response.data) {
			if (error.response.data.message !== "You don't have any active organisation" && error.response.data.message !== "No applicable cancellation policy found") {
				Utility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}
	} else {
		if (error.message !== "You don't have any active organisation") {
			Utility.toastNotifications(error.message, "Error", "error")
		}
	}
}

